<template>
    <div class="file-preview">
        <div class="popup-modal" @click="close"></div>
        <div class="modal-menu">
            <i v-if="displayDelete" @click="deleteFile" class="material-icons"
                >delete</i
            >
            <i v-if="isNotLocal" @click="download" class="material-icons"
                >save_alt</i
            >
            <i @click="close" class="material-icons">close</i>
        </div>
        <div class="modal-content">
            <div
                style="margin: auto; height: 50vw; width: 90vh;"
                v-if="file.type == 'movie'"
            >
                <VideoPlayer :src="file.path" />
            </div>
            <v-img v-if="file.type == 'image'" :url="source" />
            <pdf
                class="preview-pdf"
                v-if="file.type == 'pdf'"
                :src="source"
            ></pdf>
            <div class="iframe-wrap" v-if="useOfficePreview">
                <iframe
                    class="doc-iframe"
                    :src="
                        `https://view.officeapps.live.com/op/view.aspx?src=${source}`
                    "
                ></iframe>
            </div>
            <div v-if="file.type == 'file'">
                <div class="preview-placeholder">
                    {{ $t('LABEL_PREVIEW_NOT_AVAILABLE') }}
                </div>
                <div class="preview-placeholder -subplaceholder">
                    {{ $t('LABEL_FORMAT_NOT_SUPPORTED') }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import pdf from 'vue-pdf'
export default {
    components: {
        pdf
    },
    props: {
        file: Object,
        displayDelete: Boolean,
        displayReceivers: Boolean
    },
    data() {
        return {
            sheetHtml: '',
            docHtml: ''
        }
    },
    computed: {
        useOfficePreview() {
            return (
                (this.file.type == 'word' || this.file.type == 'excel') &&
                !this.file.local
            )
        },
        isNotLocal() {
            return !this.file.local
        },
        source() {
            return this.file.local
                ? this.file.path
                : this.$Utils.convertImageUrl(this.file.path)
        }
    },
    methods: {
        showReceivers() {
            this.$emit('showReceivers')
        },
        copyLink() {
            this.$copyText(this.file.path).then(() => {
                this.$Notif.success()
            })
        },
        download() {
            if (!this.file) {
                return
            }
            this.$Network.downloadFile(this.file.path)
        },
        deleteFile() {
            this.$emit('delete', this.file)
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.popup-modal {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: $high;
    cursor: pointer;
    background: $modal-background;
    transition: all 0.5s ease;
}
.file-preview {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: $highest;
    padding: 4rem;
    box-sizing: border-box;
}
.modal-menu {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px;
    z-index: $highest;
}
.modal-menu i {
    color: var(--color);
    z-index: $highest;
    font-size: 2rem;
    margin-left: 1rem;
    transition: $ease;
    cursor: pointer;

    &:hover {
        transform: $translateY;
    }
}
.modal-content {
    z-index: $highest;
    text-align: center;
}
.modal-content img {
    min-width: 30vw;
    max-width: 50vw;
    max-height: 90vh;
}
.preview-pdf {
    width: 40vw;
    min-width: 700px;
    max-height: 90vh;
    overflow: hidden;
    overflow-y: scroll;
    margin: 10vh;
}
.preview-placeholder {
    color: var(--color);
    font-size: 55px;
    font-family: $input-family;
    text-align: center;
    z-index: $highest;

    &.-subplaceholder {
        font-size: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
.preview-download {
    cursor: pointer;
    transition: 0.3s ease all;

    &:hover {
        transform: translateY(3px);
    }
}
.iframe-wrap {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: $highest;
}
.doc-iframe {
    box-shadow: $modal-shadow;
    height: 85vh;
    width: 40vw;
    min-width: 700px;
    border: none;
}
.sheet-preview {
    height: 85vh;
    max-width: 40vw;
    min-width: 700px;
    border: none;
    background: #fff;
    padding: 2rem;
    overflow-x: auto;
    border-radius: $input-radius;

    /deep/ table {
        border-collapse: collapse;
    }
    /deep/ td {
        border: $list-border;
        min-height: 1rem;
        min-width: 5rem;
    }
    /deep/ tr {
        height: 1.5rem;
        min-width: 1rem;
    }
}
</style>
